import { createApp } from 'vue'
import App from './App.vue'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/index.css'
import router from './router';
import i18n from './locales'
import SvgIcon from '@/icons/index.vue'

const req = require.context('@/icons', false, /.svg$/)
req.keys().map(req)

const app = createApp(App)
app.use(router);
app.use(ElementPlus)
app.use(i18n)
app.component('svg-icon', SvgIcon)

app.mount('#app')
